<template>
    <section class="o-services-modal-inner-otg">
        <ATextButton
            :text="$t('ui.close')"
            icon="close-black"
            class="close-button"
            @onClick="onClickClose"
        />
        <div class="services-modal-inner-otg-container">
            <img
                v-if="itemIcon"
                :src="itemIcon"
                class="service-icon"
            >
            <span class="service-name">
                {{ itemName }}
            </span>
            <span class="service-name" v-if="isShowServiceName">
                {{ item.name }}
            </span>
            <span class="service-floor" v-if="isShowFloorInfo">
                {{ itemFloor }}
            </span>
            <span
                v-if="distance"
                class="service-distance"
            >
                {{ distanceMessage }}
            </span>
        </div>
        <div class="services-modal-inner-otg-footer">
            <AButtonOtg
                :title="$t('ui.show-fastest-way')"
                class="footer-button"
                v-if="isDisabledFastGuide"
                @onClick="onClickFast"
            />
            <AButtonOtg
                :title="$t('ui.wheelchair-users-way')"
                class="footer-button"
                theme="white"
                v-if="isDisabledEasyGuide"
                @onClick="onClickEasy"
            />
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

import AButtonOtg from '../../atoms/a-button-otg';
import ATextButton from '../../atoms/a-text-button';

import {
    FAST,
    EASY
} from "../../../utils/constants/app-constants";
import { TERMINAL_STANDARD_GUIDE } from "../../../utils/constants/pages";

export default {
    name: 'OModalItemDetailsOtg',
    props: {
        item: {
            type: Object,
            required: true
        },
        itemName: {
            type: String,
            default: ''
        }
    },
    components: {
        AButtonOtg,
        ATextButton
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp'
        ]),
        itemIcon() {
            return this.t(this.item, 'icon') || '';
        },
        itemFloor() {
            return this.t(this.item, 'floor') || '';
        },
        distance() {
            return this.item?.distance || 0;
        },
        distanceMessage() {
            return `Avstand: ${this?.distance} meter`;
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OModalItemDetailsOtg.params') || {};
        },
        isDisabledGuideBtn() {
            return this.commonConfigParams.disabled_guide_btn
        },
        isDisabledFastGuide() {
            return this.t(this.item, 'fast_guide')
        },
        isDisabledEasyGuide() {
            return this.t(this.item, 'easy_guide')
        },
        isShowServiceName() {
            return this.itemName !== this.item.name
        },
        isShowFloorInfo() {
            if (this.commonConfigParams.hasOwnProperty('is_show_floor_info')) {
                return this.commonConfigParams.is_show_floor_info
            }
            return true
        },
    },
    methods: {
        onClickClose() {
            this.$emit('onClose');
        },
        onClickFast() {
            this.redirectToPathFrame(FAST);
        },
        onClickEasy() {
            this.redirectToPathFrame(EASY);
        },
        redirectToPathFrame(mode) {
            const payload = {
                name: TERMINAL_STANDARD_GUIDE,
                params: {
                    itemId: this.item.id,
                    mode
                }
            };
            this.$emit('onClose')
            this.$router.replace(payload);
            this.onClickClose();
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
